/**
 * Lightweight analytics for insight impressions and clicks.
 * Dual-track: Plausible + GTM (dataLayer) for consistency.
 */
export function trackInsightImpression(insightId) {
  if (typeof window === 'undefined') return;
  if (window.plausible) {
    window.plausible('Budget Insight Impression', { props: { insight: insightId } });
  }
  if (window.dataLayer) {
    window.dataLayer.push({ event: 'budget_insight_impression', insight: insightId });
  }
}

export function trackInsightClick(insightId, ctaPath) {
  if (typeof window === 'undefined') return;
  if (window.plausible) {
    window.plausible('Budget Insight Click', { props: { insight: insightId, cta: ctaPath } });
  }
  if (window.dataLayer) {
    window.dataLayer.push({ event: 'budget_insight_click', insight: insightId, cta: ctaPath });
  }
}
